<template>
  <div class="main">
    <div class="main-desc">
      <div>
        <el-image :src="require('../assets/image/descyuan.jpg')" class="main-img">
          <div slot="placeholder" class="custom-loading">
            <!-- 这里是你的自定义加载动画 -->
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
      </div>
      <div>
        <el-button class="btn" :type="activeArea.indexOf('1') > -1 || (0 < activeItem && activeItem < 4) ? 'primary' : ''" round size="small" @click="handleAreaClick('1')">清江流域</el-button>
        <el-button class="btn" :type="activeArea.indexOf('2') > -1 || (3 < activeItem && activeItem < 14) ? 'primary' : ''" round size="small" @click="handleAreaClick('2')">酉水流域</el-button>
        <el-button class="btn" :type="activeArea.indexOf('3') > -1 || (13 < activeItem && activeItem < 18) ? 'primary' : ''" round size="small" @click="handleAreaClick('3')">沅水流域</el-button>
        <el-button class="btn" :type="activeArea.indexOf('4') > -1 || 17 < activeItem ? 'primary' : ''" round size="small" @click="handleAreaClick('4')">其他织锦</el-button>
        <el-image :src="require('../assets/image/legyuan.jpg')" class="main-img">
          <div slot="placeholder" class="custom-loading">
            <!-- 这里是你的自定义加载动画 -->
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
        <span class="beian">网站备案号：渝ICP备2024032881号-1</span>
      </div>
    </div>
    <div class="main-con">
      <div class="chart-box">
        <div class="chart-y">
          <div :class="activeArea.indexOf('1') > -1 || (0 < activeItem && activeItem < 4) ? 'r' : ''" @click="handleAreaClick('1')">清江流域</div>
          <div :class="activeArea.indexOf('2') > -1 || (3 < activeItem && activeItem < 14) ? 'g' : ''" @click="handleAreaClick('2')">酉水流域</div>
          <div :class="activeArea.indexOf('3') > -1 || (13 < activeItem && activeItem < 18) ? 'b' : ''" @click="handleAreaClick('3')">沅水流域</div>
          <div :class="activeArea.indexOf('4') > -1 || 17 < activeItem ? 'y' : ''" @click="handleAreaClick('4')">其他织锦</div>
        </div>
        <div class="chart">
          <div :class="['chart-a', activeArea.indexOf('1') > -1 || (0 < activeItem && activeItem < 4) ? 'chart1' : '']"></div>
          <div :class="['chart-a', activeArea.indexOf('2') > -1 || (3 < activeItem && activeItem < 14) ? 'chart2' : '']"></div>
          <div :class="['chart-a', activeArea.indexOf('3') > -1 || (13 < activeItem && activeItem < 18) ? 'chart3' : '']"></div>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="古代巴人是土家先民之一，土家先民的织造历史可以追溯到公元前316年左右。在当时，蜀的织造水平相当不错，“蜀”即蚕的象形字，很早“蚕氏”就以野蚕抽丝织帛。可见这时期，一部分土家先民的织造已摆脱了原始的初级形态，以完成“纴织之功”的类似编织方式，进入了一个新阶段。"
          >
            <div :class="['tip', activeArea.indexOf('1') > -1 || activeItem == '1' ? 'r' : '']" @click="handleItemClick(1)" slot="reference">
              巴氏织造
              <p class="desc">(巴人)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="幏布和賨布是指以清江流域和酉水流域两区域的同一种类织物。賨布是土家织锦西兰卡普的前身，而“西兰卡普”的“卡普”与“幏布”在西南官话中语音大同小异，由于土家语的汉语音译，加之音译人的主观处理，导致传播过程中有所曲解。"
          >
            <div :class="['tip tip2', activeArea.indexOf('1') > -1 || activeItem == '2' ? 'r' : '']" @click="handleItemClick(2)" slot="reference">
              幏布
              <p class="desc">(南郡诸少数民族)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="清江流域社会经济发展较快，外来文化冲击比较大。在清代顾采的《容美纪游》中有这样的记载:“民家多以纺织为业”，“峒被如锦，土丝所织，贵者与缎同价，龙风金碧，堪为被褥”。显然这一时期的“峒被”已经高度汉化并逐步淡化消亡，成为清江流域“幏布”发展的最后辉煌。"
          >
            <div :class="['tip tip3', activeArea.indexOf('1') > -1 || activeItem == '3' ? 'r' : '']" slot="reference" @click="handleItemClick(3)">峒被</div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="早在6000年前的新石器时期，酉水流域原始居民与濮人融合后的土家族古老先民，就开始从树皮上取纤维，纺布用以穿着。商周以后，这些“土著”利用野生纤维“葛麻”进行原始“织造”已经相当普遍。专家称“这是研究酉水流域民族起源的首把钥匙”。"
          >
            <div :class="['tip tip4', activeArea.indexOf('2') > -1 || activeItem == '4' ? 'g' : '']" slot="reference" @click="handleItemClick(4)">
              葛麻原始织造
              <p class="desc">(湘西北土著濮僚及其后裔)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="秦灭巴后，巴人（又称賨人、巴賨）定居于黔中郡，即今天的武陵土家地区。汉代改为武陵郡，岁令大人输布一匹、小口二丈，是谓“賨布”。这种賨布以麻为主纤维，是武陵“土著”与“賨人”融合后，将巴国相对现金的织造技术与土家族先民的原始织造相结合而形成的一种织物形式。"
          >
            <div :class="['tip tip5', activeArea.indexOf('2') > -1 || activeItem == '5' ? 'g' : '']" @click="handleItemClick(5)" slot="reference">
              賨布
              <p class="desc">(武陵土著及賨人)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="周代中原与西北交换纺织品，学会了“以毳毛织罽”的技术，并较为盛行。这是一种以纬纱起花的织造。《史记·西南夷传》中又云：汉代居住在西南一带的少数民族受中原的影响，也学会各种用颜色的毛纱，织成斑斓多彩的斑罽（又称斑花罽），大大促进了当地賨布的发展。"
          >
            <div :class="['tip tip6', activeArea.indexOf('2') > -1 || activeItem == '6' ? 'g' : '']" @click="handleItemClick(6)" slot="reference">
              斑花罽
              <p class="desc">(西南一带少数民族)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="湘西北“土著”濮僚及其后裔，在继野生“葛麻”进行原始“织造”之后，又逐步利用桑科栲属的植物，如桑树、构树等，其皮中均可以析离出供织造用的纤维。经剥皮、捶打、沤泡、析条、辑纱、漂煮等六道工序，可绩成供织布的树皮纤维般的“纱”。再用类似水平式踞织腰机的织造方法，得到一种红白相间的原始意义上的织锦——“圈布”。"
          >
            <div :class="['tip tip7', activeArea.indexOf('2') > -1 || activeItem == '7' ? 'g' : '']" @click="handleItemClick(7)" slot="reference">
              圈布
              <p class="desc">(湘西北土著濮僚及其后裔)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="兰干细布是西兰卡普历史发展过程中继賨布之后的另一个高峰。“兰干”在湘西北土家先民中称为“纻”（紵），是一种苎麻类织物。以苎麻织成的布与普通的“麻布”有所不同，它是将染成五色的线再织成布，所以这种布呈现出的“斑”花漂亮如绫锦。"
          >
            <div :class="['tip tip8', activeArea.indexOf('2') > -1 || activeItem == '8' ? 'g' : '']" @click="handleItemClick(8)" slot="reference">
              兰干细布
              <p class="desc">(濮人及其后裔僚人)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="斑布，顾名思义是一种有斑斓花纹的织物，以形彩而得名,但没有土锦那么丰富的纹饰，原来大多数为麻纤维，后来逐步采用了棉，工艺为通经通纬的条状或网状的图案织物。它作为一种带有条纹的家机土布，比兰干细布又进步了许多，是从“布”到“锦”的必然产物。"
          >
            <div :class="['tip tip9', activeArea.indexOf('2') > -1 || activeItem == '9' ? 'g' : '']" @click="handleItemClick(9)" slot="reference">
              斑布
              <p class="desc">(湘西一带)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="“溪峒”是指以酉溪（今酉水）流域一带的土家先民，明代以前，武陵山区及五溪地区还没有真正意义上的“棉”。由于“溪峒”出产有地方特色的纺织品兰干细布，所以这种特产也被称之为“溪峒布”或“溪布”“峒布”。溪峒布具有漂亮的图纹，远比“兰干”条状或网状的图纹更加丰富复杂，具备了“锦”的典型特点。"
          >
            <div :class="['tip tip10', activeArea.indexOf('2') > -1 || activeItem == '10' ? 'g' : '']" @click="handleItemClick(10)" slot="reference">
              溪峒布
              <p class="desc">(酉水一带土家先民)</p>
            </div>
          </el-popover>
          <div :class="['tip tip11', activeArea.indexOf('2') > -1 || activeItem == '11' ? 'g' : '']" @click="handleItemClick(11)">家机布</div>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="“土锦”是从斑布进化和分离出来的一种特殊品种，因色纬挖花的需要，其摆脱了“通经通维”的束缚，用“通经断纬”的方法，随心所欲的挑花织造。可见在当时“土锦”这一特定的纺织品，从织造方法到“斑斓五色”的图纹，都基本趋于成熟。与普通的土布、无图纹的土绢、刺绣品峒巾都拉开了距离。"
          >
            <div :class="['tip tip12', activeArea.indexOf('2') > -1 || activeItem == '12' ? 'g' : '']" @click="handleItemClick(12)" slot="reference">
              土锦
              <p class="desc">(土家族人)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="清“改土归流”以后，政府强行推行满汉文化，将土家人的“男女服饰不分”改为男女服装分离，一律要穿着满襟。原五彩斑斓的衣裙受到限制，从而作为土家“五彩斑衣”中主导性织物的“土锦”失去了施展的“舞台”，服饰领域重点向被盖饰品的专业方向拓展，色彩纹饰也更加大胆艳重，继而发展成为了西兰卡普。"
          >
            <div :class="['tip tip13', activeArea.indexOf('2') > -1 || activeItem == '13' ? 'g' : '']" @click="handleItemClick(13)" slot="reference">
              西兰卡普
              <p class="desc">(土家族人)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="僚(獠)为西南夷名，曾先后多次进人武陵地区。僚人善于“绩织细布”，即著名的“僚布”。它与賨布、兰干细布一样，都是以麻类纤维织成，应属同类织物。它厚如现在的卡帆布，经久耐用，纹样有“斗纹”、“斜纹”、“桂花纹”、“条花纹”等，与西兰卡普均有相同之处。"
          >
            <div :class="['tip tip14', activeArea.indexOf('3') > -1 || activeItem == '14' ? 'b' : '']" @click="handleItemClick(14)" slot="reference">
              僚布
              <p class="desc">(僚人)</p>
            </div>
          </el-popover>
          <div :class="['tip tip15', activeArea.indexOf('3') > -1 || activeItem == '15' ? 'b' : '']" @click="handleItemClick(15)">
            顺水斑
            <p class="desc">(瑶族)</p>
          </div>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="沅水中游流域的泸溪、古丈与吉首交界的潭溪、八十坪、坪坝、梁家潭及排绸、丹青等地也有一种手工艺织锦被面，当地称为“芭排”，即“花被面” 的意思，亦有“倒排”(即“打花”)之 称。织物背面因断纬挖花而形成密集如麻的线条，形似牛肚，故而汉语俗称“牛肚被面”。"
          >
            <div :class="['tip tip16', activeArea.indexOf('3') > -1 || activeItem == '16' ? 'b' : '']" @click="handleItemClick(16)" slot="reference">
              牛肚被面
              <p class="desc">(仡佬人及苗族)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="苗锦以纬丝起花，采用多把小梭子织造。采用彩色经纬丝，基本组织为人字斜纹、菱形斜纹或复合斜纹，多用小型几何纹样。苗族服装用以镶嵌衣领、衣袖或作其他装饰。开口用多片综（或提经竿）,可以兼用挖梭织法。制作比较费时，但纹样色彩优美，富有民族风格。"
          >
            <div :class="['tip tip17', activeArea.indexOf('3') > -1 || activeItem == '17' ? 'b' : '']" @click="handleItemClick(17)" slot="reference">
              苗锦
              <p class="desc">(苗族)</p>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="中国四大名锦之一，采用的是手工织造的方式和“彩条起彩，经线显花”技术。它的色彩鲜艳、图案精美，寓意着吉祥、富贵和幸福。最早可以追溯到战国时期，兴于秦汉，盛于唐宋，衰于明末，清代中晚期得以恢复。2006年，列入第一批国家级非物质文化遗产名录。"
          >
            <div :class="['tip tip18', activeArea.indexOf('4') > -1 || activeItem == '18' ? 'y' : '']" @click="handleItemClick(18)" slot="reference">蜀锦</div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="中国四大名锦之一，一直保留着传统的提花木机织造。因其色泽光丽灿烂，美如天上云霞而得名，被誉为“锦中之冠”。其历史可追溯至东晋义熙十三年在国都建康（今南京）设立专门管理织锦的官署——锦署。2006年，列入第一批国家级非物质文化遗产名录。"
          >
            <div :class="['tip tip19', activeArea.indexOf('4') > -1 || activeItem == '19' ? 'y' : '']" @click="handleItemClick(19)" slot="reference">
              <div class="line"></div>
              云锦
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="中国四大名锦之一，意为天纹之页，据传约起源于宋代，以棉、麻线作地经、地纬平纹交织，用于制做衣裙、巾被、背包、台布等。其图案生动，结构严谨，色彩斑斓，充满热烈、开朗的民族格调，曾作为贡品晋献皇宫。2006年，列入第一批国家级非物质文化遗产名录。"
          >
            <div :class="['tip tip20', activeArea.indexOf('4') > -1 || activeItem == '20' ? 'y' : '']" @click="handleItemClick(20)" slot="reference">壮锦</div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="click"
            content="中国四大名锦之一，始于宋代末年,是在唐代蜀锦的基础上发展起来的。因其主要产地在苏州，故又称“苏州宋锦”。宋锦色泽华丽，图案精致，质地坚柔，被赋予中国“锦绣之冠”,主要用于宫殿、堂室内的陈设。2006年，列入第一批国家级非物质文化遗产名录。"
          >
            <div :class="['tip tip21', activeArea.indexOf('4') > -1 || activeItem == '21' ? 'y' : '']" @click="handleItemClick(21)" slot="reference">宋锦</div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {EventBus} from '../utils/eventBus.js'
export default {
  name: 'Yuan',
  data() {
    return {
      activeArea: ['2'],
      activeItem: '-1'
    }
  },
  mounted() {},
  methods: {
    handleAreaClick(i) {
      if(window.localStorage.getItem('isPlay') == "true"){
        EventBus.$emit('isPlay')
      }
      this.activeItem = '-1'
      let j = this.activeArea.indexOf(i)
      if (j > -1) {
        this.activeArea.splice(j, 1)
      } else {
        this.activeArea.push(i)
      }
      console.log(this.activeArea)
    },
    handleItemClick(i) {
      if(window.localStorage.getItem('isPlay') == "true"){
        EventBus.$emit('isPlay')
      }
      this.activeItem = i
      this.activeArea = []
    }
  }
}
</script>
<style lang="scss" scoped>
.main-con {
  align-items: center;
}
.main-desc {
  flex-shrink: 0;
  max-height: 798px;
}
.chart-box {
  display: flex;
  .chart-y {
    width: 35px;
    & > div {
      cursor: pointer;
      height: 167.5px;
      font-size: 18px;
      color: #000;
      background-color: #727171;
      font-weight: bold;
      display: flex;
      align-items: center;
      text-align: center;
      &.g {
        background-color: #00c76c;
      }
      &.r {
        background-color: #fa5649;
      }
      &.b {
        background-color: #00b1e2;
      }
      &.y {
        background-color: #f6a31e;
      }
    }
  }
  .chart {
    width: 1185px;
    height: 710px;
    background-image: url('../assets/image/bgh.jpg');
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;
    .chart-a {
      position: absolute;
      width: 1185px;
      height: 710px;
      background-size: contain;
      background-repeat: no-repeat;
      &.chart1 {
        background-image: url('../assets/image/bjh.png');
      }
      &.chart2 {
        background-image: url('../assets/image/bgg.png');
      }
      &.chart3 {
        background-image: url('../assets/image/bjl.png');
      }
    }

    .tip {
      font-size: 20px;
      text-align: center;
      padding: 2px 2px 4px;
      background-color: #606060;
      position: absolute;
      left: 179px;
      top: 68px;
      letter-spacing: 2px;
      font-family: SourceHanSansCNBold;
      cursor: pointer;
      &.tip2 {
        left: 479px;
        &::after {
          height: 551px;
        }
      }

      &.tip3 {
        left: 966px;
        &::after {
          height: 565px;
        }
      }
      &.tip4 {
        left: 155px;
        top: 230px;
        &::after {
          height: 389px;
        }
      }
      &.tip5 {
        left: 479px;
        top: 148px;
        &::after {
          height: 470px;
        }
      }
      &.tip6 {
        left: 472px;
        top: 229px;
        &::after {
          height: 390px;
        }
      }
      &.tip7 {
        left: 460px;
        top: 306px;
        &::after {
          height: 313px;
        }
      }
      &.tip8 {
        left: 614px;
        top: 235px;
        &::after {
          height: 385px;
        }
      }
      &.tip9 {
        left: 749px;
        top: 235px;
        &::after {
          height: 383px;
        }
      }
      &.tip10 {
        left: 828px;
        top: 235px;
        &::after {
          height: 383px;
        }
      }
      &.tip11 {
        left: 878px;
        top: 152px;
        &::after {
          height: 481px;
        }
      }
      &.tip12 {
        left: 950px;
        top: 193px;
        &::after {
          height: 426px;
        }
      }
      &.tip13 {
        left: 1018px;
        top: 240px;
        &::after {
          height: 379px;
        }
      }
      &.tip14 {
        left: 564px;
        top: 483px;
        &::after {
          height: 136px;
        }
      }
      &.tip15 {
        left: 843px;
        top: 402px;
        &::after {
          height: 217px;
        }
      }
      &.tip16 {
        left: 934px;
        top: 402px;
        &::after {
          height: 217px;
        }
      }
      &.tip17 {
        left: 1036px;
        top: 402px;
        &::after {
          height: 217px;
        }
      }

      &.tip18 {
        left: 569px;
        top: 551px;
        &::after {
          height: 82px;
        }
      }
      &.tip19 {
        left: 616px;
        top: 494px;
        .line {
          position: absolute;
          top: 143%;
          left: -49px;
          width: 49px;
          height: 1px;
          background-color: #606060;
        }
        &::after {
          height: 124px;
          left: -49px;
          top: 51px;
        }
      }
      &.tip20 {
        left: 780px;
        top: 618px;
        &::after {
          height: 0;
        }
      }
      &.tip21 {
        left: 847px;
        top: 587px;
        &::after {
          height: 46px;
        }
      }

      &::before {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        width: 0;
        height: 0;
        border-left: 7px solid #606060;
        border-right: 7px solid transparent;
        border-top: 8px solid #606060;
        border-bottom: 8px solid transparent;
      }
      &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        width: 1px;
        height: 551px;
        background-color: #606060;
      }
      &.g {
        z-index: 3;
        background-color: #00c76c;

        &::before {
          border-left-color: #00c76c;
          border-top-color: #00c76c;
        }
        &::after {
          background-color: #00c76c;
        }
      }
      &.r {
        z-index: 3;
        background-color: #fa5649;
        &::before {
          border-left-color: #fa5649;
          border-top-color: #fa5649;
        }
        &::after {
          background-color: #fa5649;
        }
      }
      &.b {
        z-index: 3;
        background-color: #00b1e2;
        &::before {
          border-left-color: #00b1e2;
          border-top-color: #00b1e2;
        }
        &::after {
          background-color: #00b1e2;
        }
      }
      &.y {
        z-index: 3;
        background-color: #f6a31e;
        &.tip19 {
          .line {
            background-color: #f6a31e;
          }
        }
        &::before {
          border-left-color: #f6a31e;
          border-top-color: #f6a31e;
        }
        &::after {
          background-color: #f6a31e;
        }
      }
      .desc {
        font-size: 9px;
        letter-spacing: 1px;
        font-family: SourceHanSansCNMedium;
      }
    }
  }
}
</style>
